var chunkMapping = {
	"43": [
		2043
	],
	"69": [
		8069
	],
	"304": [
		888
	],
	"308": [
		6308
	],
	"505": [
		1505
	],
	"725": [
		8725
	],
	"728": [
		2728
	],
	"733": [
		733
	],
	"752": [
		5752
	]
};
var idToExternalAndNameMapping = {
	"733": [
		"default",
		"./OrdersHub",
		398
	],
	"888": [
		"default",
		"./OrderManager",
		398
	],
	"1505": [
		"default",
		"./Catalog",
		621
	],
	"2043": [
		"default",
		"./ArchivedOrders",
		398
	],
	"2728": [
		"default",
		"./DownloadsManager",
		398
	],
	"5752": [
		"default",
		"./OrderReadOnly",
		398
	],
	"6308": [
		"default",
		"./Customers",
		398
	],
	"8069": [
		"default",
		"./MDOManager",
		398
	],
	"8725": [
		"default",
		"./CustomerDetails",
		398
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}